// Code values for Finish my deck (src/lib/finishDeckFlag.ts and
// src/lib/finishReturn.ts): storage keys, a query parameter and analytics /
// paywall entry codes. The literal guard skips *.codes.ts files by design.
export const FINISH_DECK_STORAGE_KEY = 'cb.finishDeck'
export const FINISH_DECK_QUERY_PARAM = 'finish_deck'
/** sessionStorage: the deck a guest left for sign-in from the Finish button. */
export const FINISH_RETURN_KEY = 'cb.finishReturn'
/** sessionStorage: guest deck id -> account deck id, written by a migration. */
export const MIGRATED_IDS_KEY = 'cb.migratedDeckIds'
/** The Paywall `entry` and the analytics trigger for this surface. */
export const FINISH_PAYWALL_ENTRY = 'finish_deck'
export const FINISH_SIGN_IN_SOURCE = 'finish_deck'
